// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3qrW3","item":"PaymentsMobile_item__3lyQo","label":"PaymentsMobile_label__2vjtH","amount":"PaymentsMobile_amount__3yqOT"};